import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Get, Set } from "../../../../../../Request";
import { ToDateJalali } from "../../../../../Common/Function";

export const useEditTimeTable = () => {
  const [data, setData] = useState({});
  const [loading, setloading] = useState({
    slug: true,
  });
  const { slug } = useParams();

  const [modal, setModal] = useState({ visible: false });
  const getSingle = async slug => {
    setloading({ slug: true });
    await Get({
      url: "/timetable/show_admin_and_manger",
      data: {
        slug,
      },
    }).then(data => {
      setData(data);
      setloading({ slug: false });
    });
  };
  const updateTimeTable = async data => {
    setloading({ ...loading, update: true });

    await Set({
      url: "/item/update_timetable",
      data: { ...data },
    }).then(() => {
      setModal({ visible: false });
      setloading({ ...loading, update: false });
    });
  };
  return { data, loading, getSingle, modal, setModal, updateTimeTable };
};
export const useContract = () => {
  const [form, setform] = useState({ times: [] });
  const [loading, setLoading] = useState({ check: false });

  const isInArray = (timekey, dayname, daykey) => {
    let res = false;
    form.times &&
      form.times.map(element => {
        if (
          element.timekey == timekey &&
          element.dayname == dayname &&
          element.daykey == daykey
        ) {
          res = true;
        }
      });
    return res;
  };
  const removeTime = (timekey, dayname, daykey) => {
    setform({
      ...form,
      times: [...form.times].filter(
        element =>
          !(
            element.timekey == timekey &&
            element.dayname == dayname &&
            element.daykey == daykey
          )
      ),
    });
  };
  const addTime = (timekey, dayname, daykey, time) => {
    setform({
      ...form,
      times: [...form.times, { timekey, dayname, daykey, time }],
    });
  };
  const toggleSelect = (timekey, dayname, daykey, data) => {
    if (isInArray(timekey, dayname, daykey)) {
      removeTime(timekey, dayname, daykey);
    } else {
      addTime(timekey, dayname, daykey, data);
    }
  };

  const arrLength = () => {
    return form.times.length;
  };

  const clearTimes = () => {
    setform({ times: [] });
  };
  const renderTimes = () => {
    if (form && form.times) {
      return form.times.map(time => {
        return (
          <div className="border rounded p-2 m-2">
            <h6 className="text-center">{`${time.time.start} تا ${time.time.end}`}</h6>
            <h6 className="text-center">{ToDateJalali(time.time.date)}</h6>
          </div>
        );
      });
    }
  };

  const submit = async (item_id, active = false, newDate = 1) => {
    setLoading({ ...loading, submit: true });
    Set({
      url: "/item/update_timetable",
      data: {
        action: "change_capacity",
        multitimes: form.times,
        status: active ? "active" : "deactive",
        item_id,
        capacity: newDate,
      },
    }).then(res => {
      setLoading({ ...loading, submit: false });
    });
  };

  const submitRange = async (item_id, active = false, newDate = 1, rangeData) => {
    setLoading({ ...loading, submit: true });
    Set({
      url: "/item/update_timetable",
      data: {
        action: "change_capacity",
        multitimes: form.times,
        status: active ? "active" : "deactive",
        item_id,
        capacity: newDate,
        date_start: rangeData.rangeStartDate,
        date_end: rangeData.rangeEndDate,
      },
    }).then(res => {
      setLoading({ ...loading, submit: false });
    });
  };

  return {
    toggleSelect,
    arrLength,
    isInArray,
    // checkTimes,
    loading,
    // checkDate,
    clearTimes,
    renderTimes,
    submit,
    submitRange
  };
};
